const getUsers = state => { return state.foundUser }

export default {
  getUsers,
}
